import _objectSpread from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _asyncToGenerator from "/media/disk1/fordata/jenkins/rbdNodeJs/workspace/SRC/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.match.js";
import { defineComponent, reactive, onMounted, toRefs } from '@vue/composition-api';
import yoda from '@ks/yoda-js-sdk';
export default defineComponent({
  name: 'top-bar',
  /**
  * title：标题，必须
  * color: 颜色
  * bgColor: 背景颜色
  * takePlace：是否占位。默认占位
  */
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#fff'
    },
    bgColor: {
      type: String,
      default: 'transparent'
    },
    takePlace: {
      type: Boolean,
      default: true
    },
    inApp: {
      type: Boolean,
      default: true
    },
    showRight: {
      type: Boolean,
      default: true
    },
    animation: {
      type: String,
      default: 'fadeIn'
    },
    showDefaultTitle: {
      type: Boolean,
      default: false
    }
  },
  emits: ['clickRight', 'clickLeft'],
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      refs = _ref.refs;
    // 获取yoda容器statusbar高度及导航栏高度，默认为30或50
    var userAgent = navigator.userAgent;
    var StatusHT = Number((userAgent.match(/StatusHT\/\d+/g) || ['StatusHT/20'])[0].split('/')[1]);
    // const TitleHT = Number((userAgent.match(/TitleHT\/\d+/g) || (['TitleHT/44'] as RegExpMatchArray))[0].split('/')[1]);
    // 安卓title是50有问题 先写死44
    var TitleHT = 44;
    var exitWebview = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                emit('clickLeft');
                _context.next = 3;
                return yoda.ready();
              case 3:
                _context.next = 5;
                return yoda.webview.backOrClose();
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function exitWebview() {
        return _ref2.apply(this, arguments);
      };
    }();
    var state = reactive({
      opacity: 0,
      navHeight: 0,
      showTitle: props.showDefaultTitle
    });
    var clickRight = function clickRight() {
      emit('clickRight');
    };
    var handleScroll = function handleScroll() {
      var scrollTop = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
      // 滚动距离占nav整体高度比例
      var proportion = Number(scrollTop / state.navHeight);
      proportion = proportion > 1 ? 1 : proportion;
      if (props.animation === 'fadeIn') {
        state.opacity = proportion;
        state.showTitle = props.showDefaultTitle ? true : scrollTop !== 0;
      }
    };
    onMounted(function () {
      window.addEventListener('scroll', handleScroll, false);
      state.navHeight = refs['header-nav'].clientHeight;
    });
    return _objectSpread({
      StatusHT: StatusHT,
      TitleHT: TitleHT,
      exitWebview: exitWebview,
      clickRight: clickRight
    }, toRefs(state));
  }
});